import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { FaxStatuses } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FaxStatusOption } from 'src/app/pages/fax-register/models/fax-status-option.interface';
import { addSpacesToTypeName } from 'src/app/pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { faxStatusOptionSelectors } from '../state/fax-status-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: FaxStatusSelectComponent,
        },
    ],
    selector: 'ndt-fax-status-select',
    templateUrl: './fax-status-select.component.html',
    standalone: false
})
export class FaxStatusSelectComponent extends LcsSingleSelectBase<FaxStatusOption> implements OnInit {
   @Input() excludedFaxStatuses: FaxStatuses[] = [];

   @Input() includedFaxStatuses: FaxStatuses[] | null;

   faxStatuses$: Observable<FaxStatusOption[]>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.faxStatuses$ = this.store.pipe(
         select(faxStatusOptionSelectors.selectFilteredItems),
         map((items: Array<FaxStatusOption>) => {
            let filteredItems = items;

            if (!this.includedFaxStatuses && this.excludedFaxStatuses && this.excludedFaxStatuses.length > 0) {
               filteredItems = filteredItems.filter((item) => {
                  return !this.excludedFaxStatuses?.includes(item.typeName as FaxStatuses);
               });
            }

            if (!this.excludedFaxStatuses && this.includedFaxStatuses && this.includedFaxStatuses.length > 0) {
               filteredItems = filteredItems.filter((item) => {
                  return this.includedFaxStatuses?.includes(item.typeName as FaxStatuses);
               });
            }
            return filteredItems;
         })
      );
   }

   displayWith(item: FaxStatusOption | null): string | null {
      return item ? (item.typeName ? addSpacesToTypeName(item.typeName) : null) : null;
   }

   trackBy(item: FaxStatusOption | null) {
      return item ? item.typeName : null;
   }
}
